import React from "react";
import { Link } from "react-router-dom";
import { useUserAuth } from "../User/UserAuthContext/UserAuthContext";
import FeeSPop2 from "../../src/assests/FeeSticky2.png";
import "./Home2.css";

function StickyVideoUp() {
  const { user } = useUserAuth();
  return (
    <>
      {user ? (
        <Link to="/register-form" className="BlikingText">
          <div className="blink">
            <p>Upload your 1 minute cricket video clip</p>
          </div>
          {/* <div class="FeeDetailsH"><p>Clip uploading fee ₹50 only</p></div> */}
        </Link>
      ) : (
        <Link to="/Login" className="BlikingText">
          <div className="blink">
            <p>Upload your 1 minute cricket video clip</p>
          </div>
          {/* <div class="FeeDetailsH"><p>Clip uploading fee ₹50 only</p></div> */}
        </Link>
      )}

      {user ? (
        <Link to="/register-form" className="popup-home">
          <div className="modal">
            <div className="modal-content">
              {/* <span className="close" onClick={closeModal}>&times;</span> */}
              {/* <p>This is a sticky modal!</p> */}
              <img src={FeeSPop2} alt="" />
            </div>
          </div>
        </Link>
      ) : (
        <Link to="/Login" className="popup-home">
          <div className="modal">
            <div className="modal-content">
              {/* <span className="close" onClick={closeModal}>&times;</span> */}
              {/* <p>This is a sticky modal!</p> */}
              <img src={FeeSPop2} alt="" />
            </div>
          </div>
        </Link>
      )}
    </>
  );
}

export default StickyVideoUp;
